import { FETCH_USER_SUCCESS, FETCH_USER_ERROR } from '../constants/ActionTypes';

export default function fetchUserError(state = false, action) {
    switch (action.type) {
        case FETCH_USER_SUCCESS:
            return false;

        case FETCH_USER_ERROR:
            return true;
        default:
            return state;
    }
}
